import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome'
import { config } from '@fortawesome/fontawesome-svg-core'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  config.autoAddCss = false
  nuxtApp.vueApp.component('fa', FontAwesomeIcon)
  nuxtApp.vueApp.component('fa-layers', FontAwesomeLayers)
})
